import axios from 'axios';
import { AppUser } from '../../views/App/App';
import { SupportExpectation, SupportQueue, SupportThreadDetail, SupportSendReceipt } from '../../models/supportEmail';

export type SupportAction = 'generate' | 'edit' | 'approve' | 'reject' | 'send';
export function getSupportThreads(user: AppUser, skip = 0, limit = 20): Promise<SupportQueue> {
  return axios
    .get(`${window.apiBase}/admin/support/threads`, {
      headers: { usid: user.sessionKey },
      params: { filter: JSON.stringify({ skip, limit }) },
    })
    .then(response => response.data);
}
export function getSupportThread(user: AppUser, id: string): Promise<SupportThreadDetail> {
  return axios
    .get(`${window.apiBase}/admin/support/threads/${encodeURIComponent(id)}`, {
      headers: { usid: user.sessionKey },
    })
    .then(response => response.data);
}
export function supportAction(
  user: AppUser,
  threadId: string,
  draftId: string | undefined,
  action: SupportAction,
  expected: SupportExpectation,
  extra: { text?: string; note?: string } = {}
): Promise<SupportSendReceipt | unknown> {
  const path =
    `${window.apiBase}/admin/support/threads/${encodeURIComponent(threadId)}/draft` +
    (action === 'generate' ? '' : `/${encodeURIComponent(draftId)}/${action}`);
  // Never accept a recipient, arbitrary Image ID or reviewer identity from the browser.
  return axios
    .post(
      path,
      {
        reviewVersion: expected.reviewVersion,
        messageRevision: expected.messageRevision,
        processingAttemptId: expected.processingAttemptId,
        ...(action === 'edit' ? { text: extra.text } : {}),
        ...(action === 'reject' ? { note: extra.note } : {}),
      },
      { headers: { usid: user.sessionKey } }
    )
    .then(response => response.data);
}
